
import { supabase } from "@/integrations/supabase/client";
import { sendInvoiceEmail } from "./invoice-utils";

/**
 * Reactivates a past due subscription
 */
export const reactivateSubscription = async (
  subscriptionId: string, 
  productId: string,
  planId: string,
  schoolId: string,
  userEmail: string
) => {
  console.log('Reactivating past_due subscription:', subscriptionId);
  
  const subscriptionData = {
    productId: productId || '',
    planId: planId,
    schoolId: schoolId,
    userEmail: userEmail,
    reactivate: true,
    subscriptionId: subscriptionId
  };
  
  const { data: reactivationResponse, error: reactivationError } = await supabase.functions.invoke('create-subscription', {
    body: subscriptionData
  });
  
  if (reactivationError) {
    console.error('Subscription reactivation error:', reactivationError);
    throw new Error(`Failed to reactivate subscription: ${reactivationError.message || 'Unknown error'}`);
  }
  
  if (!reactivationResponse || !reactivationResponse.success) {
    console.error('Unsuccessful reactivation response:', reactivationResponse);
    throw new Error(reactivationResponse?.error || 'Unknown error reactivating subscription');
  }
  
  console.log('Subscription reactivated successfully:', reactivationResponse);
  
  // Send invoice email if there is a bill in the response
  if (reactivationResponse.bill && reactivationResponse.bill.id) {
    try {
      await sendInvoiceEmail(reactivationResponse.bill.id, userEmail);
    } catch (emailError) {
      console.error('Error sending invoice email:', emailError);
      // Don't throw here, just log the error as this shouldn't block the subscription process
    }
  }
  
  return reactivationResponse.subscription;
};
